import { render } from "./EditorWrapper.vue?vue&type=template&id=7fdd6058&scoped=true"
import script from "./EditorWrapper.vue?vue&type=script&lang=js"
export * from "./EditorWrapper.vue?vue&type=script&lang=js"

import "./EditorWrapper.vue?vue&type=style&index=0&id=7fdd6058&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fdd6058"]])

export default __exports__